/* eslint-disable react/jsx-props-no-spreading */

import { Component } from 'react';
import { translate } from '@openclassrooms/translations';
import omit from 'lodash/omit';

export class TextareaCounter extends Component {
  static defaultProps = {
    children: '',
    className: '',
    label: '',
    maxLength: null,
    onChange() {},
  };

  constructor(props) {
    super(props);
    this.textarea = null;
    this.state = {
      remainingCharacters: this.getRemainingCharacters(),
    };
  }

  getRemainingCharacters() {
    const { maxLength } = this.props;

    if (!maxLength) {
      return Infinity;
    }

    return +maxLength - this.getValue().length;
  }

  getValue() {
    const { children } = this.props;
    return this.textarea ? this.textarea.value : children;
  }

  onChange = () => {
    const { onChange } = this.props;
    this.setState({
      remainingCharacters: this.getRemainingCharacters(),
    });
    onChange(this.getValue());
  };

  init = (ref) => {
    this.textarea = ref;
  };

  renderCounter() {
    const { remainingCharacters } = this.state;
    const { maxLength } = this.props;

    if (!maxLength) {
      return null;
    }
    const labelVars = { total: remainingCharacters };
    const label = translate('global.forms.remaining_characters', labelVars);
    return <span className="textareaCounter__counter">{label}</span>;
  }

  render() {
    const { className = '', children, label, ...otherProps } = this.props;

    return (
      <span className="textareaCounter">
        <span>
          <div className="textareaCounter__label">{label}</div>
          <textarea
            className={`textareaCounter__textarea ${className}`}
            onKeyDown={this.onChange}
            onKeyUp={this.onChange}
            onChange={this.onChange}
            ref={this.init}
            defaultValue={children}
            {...omit(otherProps, ['i18n', 'onChange'])}
          />
          {this.renderCounter()}
        </span>
      </span>
    );
  }
}

export default TextareaCounter;
